'use client';

import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

const StickyFooter = dynamic(() => import('@/app_components/ads/StickyFooter').then((mod) => mod.StickyFooter), {
  ssr: false,
});

export const StickyFooterPortal = () => {
  const [portalElement, setPortalElement] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setPortalElement(document.getElementById('sticky-footer-portal'));
  }, []);

  if (!portalElement) {
    return null;
  }

  return createPortal(<StickyFooter index={0} />, portalElement);
};
